module.exports = __webpack_public_path__ + "img/pg5-article-text3.6f52308d.png";